import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'
import { DetailSkeletonBody, DetailSkeletonHeader, DetailSkeletonRoot } from './styled'

export default function NotificationDetailSkeleton({ label }) {
    return (
        <DetailSkeletonRoot aria-label={label}>
            <DetailSkeletonHeader><BaseSkeleton circle height={42} width={42} /></DetailSkeletonHeader>
            <BaseSkeleton height={34} width={130} borderRadius={999} />
            <BaseSkeleton height={52} width="72%" />
            <BaseSkeleton height={14} width={180} />
            <DetailSkeletonBody>
                <BaseSkeleton height={16} width="96%" />
                <BaseSkeleton height={16} width="91%" />
                <BaseSkeleton height={16} width="78%" />
            </DetailSkeletonBody>
        </DetailSkeletonRoot>
    )
}
